<section style="width: 100%; background-color: #eff1f4">
  <section class="login-proposal-container">
    <section class="initial-text-container ids-pt-6 ids-p-3">
      <section class="breadcrumb-box ids-row">
        <ids-icon variant="primary" aria-hidden="true">seta_esquerda</ids-icon>
        <button class="breadcrumb-tittle ids-text-insight orange" (click)="goBack()">
          crédito imobiliário Itaú
        </button>
      </section>
    </section>
  </section>
</section>
<section class="container-login">
  <section class="middle-container login-proposal-container">
    <section class="item section-buscar-financiamento-texto">
      <section class="ids-pr-10">
        <h1 class="custom-font-intro">continue com a venda do seu imóvel</h1>
        <p class="ids-text-body-01 ids-pt-8">
          Acesse o formulário com o número da proposta e com o CPF ou CNPJ para iniciar o preenchimento
        </p>
      </section>
    </section>
    <section class="item section-buscar-financiamento-card">
      <section class="card">
        <h1 class="ids-text-title-01">buscar financiamento</h1>
        <form
          class="ids-pt-6"
          [formGroup]="formularioLogin"
          (ngSubmit)="onSubmit()"
          method="post"
          autocomplete="off"
        >
          <ids-form-field
            class="ids-text-body-02"
            label="número da proposta"
            description="disponível no app Itaú do comprador"
            errorMessage="o preenchimento do número da proposta é obrigatório"
          >
            <input
              id="input-numero-proposta"
              idsInput
              formControlName="proposal"
              (keypress)="numericOnly($event)"
              maxlength="8"
              #proposal
            />
          </ids-form-field>

          <section class="ids-pt-4">
            <ids-form-field
              label="CPF ou CNPJ do vendedor"
              class="ids-text-body-02 ids-pv-4"
              [errorMessage]="getErrorInvalid('CPF ou CNPJ')"
            >
              <input
                appUpperCaseInput
                [idsMask]="maskCpfCnpj"
                id="input-numero-cpf"
                idsInput
                formControlName="cpfCnpj"
                (change)="checkValidCpfCnpj()"
              />
            </ids-form-field>
          </section>

          <section>
            <button
              id="btn-avancar-acompanhamento-proposta"
              idsMainButton
              type="submit"
              style="width: 100%"
              [disabled]="formularioLogin.invalid"
            >
              buscar
            </button>
          </section>
        </form>
      </section>
    </section>
  </section>

  <section class="item section-acesso-direto">
    <section class="login-proposal-container middle-container ids-pt-10 ids-pb-10">
      <section class="custom-image-intro">
        <img
          class="image-intro"
          *ngIf="imgIntroUrl"
          src="{{ imgIntroUrl }}"
          alt="imagem pessoa no computador"
          (error)="onLoadImageCatchError($event)"
        />
      </section>
      <section id="card-checklist-acesso-direto" class="ids-p-10">
        <h1  class="ids-text-title-02 orange ids-mb-7">Agilize o processo de financiamento</h1>
        <p class="ids-text-body-02 ids-pv-2">
          É importante que você preencha os formulários o quanto antes para avançar na venda do seu imóvel
        </p>
      </section>
    </section>
  </section>
</section>
